module.exports = __webpack_public_path__ + "img/icon1.a1ffa056.png";